// extracted by mini-css-extract-plugin
export default {"wrapper-name":"HeaderProfile_wrapper-name__pXWfQ","wrapper-attributes":"HeaderProfile_wrapper-attributes__RYEcb","attribute-item":"HeaderProfile_attribute-item__SkjTD"};